<template>
  <div class="saas-section">
    <div class="page-quote-cta__container">
      <div class="page-quote-cta">
        <div class="page-quote-cta__author">
          <div class="page-quote-cta__quote">{{ block.quote }}</div>
          <div class="page-quote-cta__author-name">{{ block.author_name }}</div>
          <div class="page-quote-cta__author-role">{{ block.author_role }}</div>
        </div>
        <div class="page-quote-cta__actions">
          <div>
            <CmsLink
              v-for="button in block.buttons"
              :key="button.id"
              :url-or-path="button.url_or_path"
              :class="`button button--${button.type} button--xlarge`"
            >
              {{ button.text }}
            </CmsLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'PageBlockQuoteCTA',
  components: { CmsLink },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
